import React from "react";
import {Form} from "antd";
import CheckboxGroupWithCheckAll from "./CheckboxGroupWithCheckAll";


export const OPTIONS = [
  { icon: "SK_2G", label: "SK 2G", iconCode: '2g-sk-out' },
  { icon: "SK_3G", label: "SK 3G", iconCode: '3g-sk-out' },
  { icon: "SK_4G", label: "SK 4G", iconCode: '4g-sk-out' },
  { icon: "KT_3G", label: "KT 3G", iconCode: '3g-kt-out' },
  { icon: "KT_4G", label: "KT 4G", iconCode: '4g-kt-out' },
  { icon: "LG_2G", label: "LG 2G", iconCode: '2g-lg-out' },
  { icon: "LG_4G", label: "LG 4G", iconCode: '4g-lg-out' },
];


function WidgetIconAtCommonUse() {
  return (
    <Form.Item>
      <CheckboxGroupWithCheckAll
        title="아이콘 종류"
        fieldName={"icon_nm_list"}
        options={OPTIONS.map(({ icon, label, iconCode }) => ({
          value: icon,
          label,
          iconCode,
        }))}
        colSpan={8} />
    </Form.Item>
  );
}


export default WidgetIconAtCommonUse;
